// Copyright © 2020  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC.

<template>
  <v-container grid-list-sm>
    <v-row wrap>
      <v-col cols="12" sm="4">
        <date-time-view
        v-model="item.dailyTime"
        clearable
        label="Start Date"
        ></date-time-view>
      </v-col>
      <v-col cols="12" sm="8">
        <v-combobox
          v-model="item.emails"
          multiple
          chips
          deletable-chips
          label="Emails"
          :rules=[emailRule]
        ></v-combobox>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

import DateTimeView from '@/components/DateTimeView'
import Rules from 'vue-common/components/rules'
import {checkPermission} from 'vue-common/components/user'
import {PERMISSIONS} from 'vue-common/components/constants'
import {LookupMixin} from '@/shared/mixins'

export default {
  mixins: [LookupMixin],

  components: {
    DateTimeView
  },

  props: {
    value: {
      type: Object,
      default: () => {}
    }
  },

  data () {
    return {
      item: this.value,
      formValid: true
    }
  },

  computed: {
    ...mapGetters([
      'accessRules'
    ]),

    canModify: function () {
      return checkPermission(this.accessRules, 'sites', PERMISSIONS.MODIFY)
    }
  },

  watch: {
    item () {
      this.$emit('input', this.item)
    },

    value (val) {
      if (this.value === null) {
        this.item = []
      } else {
        this.item = this.value
      }
    }
  },

  methods: {
    emailRule: function (addresses) {
      for (var i in addresses) {
        var o = Rules.email(addresses[i])
        if (o !== true) {
          return o
        }
      }
      return true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tabs/SiteReportSettings.vue